module.exports = __webpack_public_path__ + "img/2W.1.c8a8f3bf.jpg";